import { ActionButton, PrimaryButton } from '@fluentui/react';
import { BotAvatar } from '../BotAvatar';
import { UserAvatar } from '../UserAvatar';
import { ResourceDetails } from '../ResourceDetails';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import styles from './ChatMessage.module.sass';
import { useCustomerTheme } from '../Theme';

interface ChatMessageProps {
    message: any;
    index: number;
    isLastMessage: boolean;
    onSubmitInput: (input: string) => void;
    onFeedback: (index: number, isPositive: boolean) => void;
    resourceSelected?: (resource: any) => void;
}

export const ChatMessage = ({ message, index, isLastMessage, onSubmitInput, onFeedback, resourceSelected }: ChatMessageProps) => {
    const { theme, setTheme } = useCustomerTheme();

    switch (message.type) {
        case 'botMessage':
            return (message.content && message.content.length > 0) ||
                (message.resources && message.resources.length > 0)
                ?
                <div>
                    <div className={styles.messageContainer}>
                        <BotAvatar />
                        <div className={styles.chatBotMessage}>
                            <div className={styles.chatBotMessageArrow}></div>
                            <div className='markdown'>
                                <Markdown rehypePlugins={[rehypeRaw] as any} remarkPlugins={[remarkGfm]}>{message.content}</Markdown>
                            </div>
                        </div>
                        <div className='displayFlex justifyContentStart'>
                        </div>
                    </div>
                    {message.resources && <ResourceDetails resources={message.resources} resourceSelected={resourceSelected} />}
                    {isLastMessage && message.confirmation && (
                        <div className='displayFlex justifyContentEnd'>
                            <PrimaryButton onClick={() => onSubmitInput('yes')} text="Yes" />
                        </div>
                    )}
                    <div className={isLastMessage ? 'lastFeedbackButtons' : 'feedbackButtons'}>
                        <ActionButton
                            className='feedbackButton'
                            iconProps={{ iconName: 'Like' }}
                            onClick={() => onFeedback(index, true)}
                            ariaLabel="Thumbs up"
                        />
                        <ActionButton
                            className='feedbackButton'
                            iconProps={{ iconName: 'Dislike' }}
                            onClick={() => onFeedback(index, false)}
                            ariaLabel="Thumbs down"
                        />
                    </div>
                </div>
                : null;

        case 'botSuggestion':
            return (
                <div>
                    <div className={styles.messageContainer}>
                        <BotAvatar />
                        <div className={styles.chatBotSuggestion}>
                            {message.content}
                        </div>
                    </div>
                    {message.resources && <ResourceDetails resources={message.resources} />}
                    {isLastMessage && (
                        <div className='displayFlex justifyContentEnd'>
                            <PrimaryButton onClick={() => onSubmitInput('yes')} text="Yes" />
                        </div>
                    )}
                </div>
            );

        case 'userMessage':
            return (
                <div>
                    <div className={styles.userMessageContainer}>
                        <div className={styles.userMessage}>
                            {message.content}
                        </div>
                        <UserAvatar />
                    </div>
                </div>
            );

        default:
            return null;
    }
}; 